import { RootState } from 'store'

export const getBannerState = (state: RootState) => state.banner
export const getAffiliate = (state: RootState) => state.affiliate
export const getAffiliateMembers = (state: RootState) => state.affiliateMembers
export const getAffiliateCompetitions = (state: RootState) =>
  state.affiliateCompetitions
